import {
  FileProtectOutlined,
  InfoCircleOutlined,
  MailOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import { Alert, Card, Divider, Space, Typography } from "antd";

const { Title, Paragraph, Text, Link } = Typography;

export default function Legal() {
  return (
    <Space direction="vertical" size="large" style={{ width: "100%", maxWidth: 900 }}>
      <Card>
        <Title level={2}>
          <SafetyOutlined /> Rechtliche Hinweise
        </Title>
        <Alert
          message="Wichtiger Hinweis"
          description="Dieses Template dient ausschließlich zu Demonstrations- und Entwicklungszwecken."
          type="warning"
          showIcon
          icon={<InfoCircleOutlined />}
          style={{ marginBottom: 16 }}
        />
      </Card>

      <Card
        title={
          <>
            <FileProtectOutlined /> Impressum
          </>
        }
      >
        <Paragraph>
          <Text strong>Angaben gemäß § 5 TMG:</Text>
        </Paragraph>

        <Paragraph>
          Michael Kraemer
          <br />
          Impressumspflicht für geschäftsmäßige Online-Angebote trifft hier nicht zu!
          <br />
        </Paragraph>

        <Divider />

        <Paragraph>
          <Text strong>Kontakt:</Text>
          <br />
          <MailOutlined /> E-Mail:{" "}
          <Link href="mailto:mkraemer.mk@gmail.com">mkraemer.mk@gmail.com</Link>
          <br />
        </Paragraph>
      </Card>

      <Card title="📜 Lizenz & Open Source">
        <Paragraph>
          <Text strong>Verwendete Open Source Komponenten:</Text>
        </Paragraph>

        <ul>
          <li>
            <Link href="https://reactjs.org" target="_blank">
              React
            </Link>{" "}
            - MIT License
          </li>
          <li>
            <Link href="https://vitejs.dev" target="_blank">
              Vite
            </Link>{" "}
            - MIT License
          </li>
          <li>
            <Link href="https://ant.design" target="_blank">
              Ant Design
            </Link>{" "}
            - MIT License
          </li>
          <li>
            <Link href="https://flask.palletsprojects.com" target="_blank">
              Flask
            </Link>{" "}
            - BSD-3-Clause License
          </li>
          <li>
            <Link href="https://www.sqlalchemy.org" target="_blank">
              SQLAlchemy
            </Link>{" "}
            - MIT License
          </li>
          <li>
            <Link href="https://gunicorn.org" target="_blank">
              Gunicorn
            </Link>{" "}
            - MIT License
          </li>
        </ul>
      </Card>

      <Card title="🔒 Datenschutz">
        <Alert
          message="Datenschutz-Grundverordnung (DSGVO)"
          description="Für produktive Anwendungen muss eine vollständige Datenschutzerklärung erstellt werden, 
                      die den Anforderungen der DSGVO entspricht."
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />

        <Paragraph>
          <Text strong>Datenschutz bei diesem Template:</Text>
        </Paragraph>

        <Paragraph>Dieses Template ist so konzipiert, dass es:</Paragraph>

        <ul>
          <li>✅ Keine Tracking-Tools enthält (kein Google Analytics, etc.)</li>
          <li>✅ Keine Cookies für Marketing setzt</li>
          <li>✅ Keine Daten an Dritte weitergibt</li>
          <li>✅ Nur technisch notwendige Session-Daten speichert</li>
        </ul>
      </Card>

      <Card title="⚠️ Haftungsausschluss (Disclaimer)">
        <Paragraph>
          <Text strong>1. Inhalt des Onlineangebotes</Text>
        </Paragraph>
        <Paragraph>
          Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder
          Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, die sich
          auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung der dargebotenen
          Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen
          verursacht wurden, sind grundsätzlich ausgeschlossen.
        </Paragraph>

        <Paragraph>
          <Text strong>2. Verweise und Links</Text>
        </Paragraph>
        <Paragraph>
          Bei direkten oder indirekten Verweisen auf fremde Webseiten (&quot;Hyperlinks&quot;), die
          außerhalb des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung
          ausschließlich in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat
          und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger
          Inhalte zu verhindern.
        </Paragraph>

        <Paragraph>
          <Text strong>3. Keine Gewährleistung</Text>
        </Paragraph>
        <Paragraph>
          Dieses Template wird &quot;wie besehen&quot; (AS IS) ohne jegliche Gewährleistung
          bereitgestellt. Der Autor übernimmt keine Garantie für:
        </Paragraph>
        <ul>
          <li>Fehlerfreiheit des Codes</li>
          <li>Eignung für einen bestimmten Zweck</li>
          <li>Kompatibilität mit anderen Systemen</li>
          <li>Sicherheit vor Angriffen oder Datenverlust</li>
        </ul>

        <Paragraph>
          <Text strong>4. Nutzung auf eigene Gefahr</Text>
        </Paragraph>
        <Paragraph>
          Die Nutzung dieses Templates erfolgt ausschließlich auf eigene Gefahr. Für Schäden, die
          durch die Nutzung entstehen, wird keine Haftung übernommen.
        </Paragraph>

        <Alert
          message="Empfehlung für produktive Systeme"
          description={
            <>
              <Text>Vor dem Einsatz in Produktion:</Text>
              <ul style={{ marginBottom: 0, paddingLeft: 20, marginTop: 8 }}>
                <li>Security Audit durchführen</li>
                <li>Penetration Tests ausführen</li>
                <li>Code Review durch erfahrene Entwickler</li>
                <li>Backup-Strategie implementieren</li>
                <li>Monitoring und Logging einrichten</li>
                <li>Rechtliche Prüfung durchführen</li>
              </ul>
            </>
          }
          type="error"
          showIcon
          style={{ marginTop: 16 }}
        />
      </Card>

      <Card>
        <Paragraph style={{ textAlign: "center", marginBottom: 0 }}>
          <Text type="secondary">
            Stand:{" "}
            {new Date().toLocaleDateString("de-DE", {
              year: "numeric",
              month: "long",
            })}
          </Text>
        </Paragraph>
      </Card>
    </Space>
  );
}
